<div class="p-d-flex p-flex-column p-fluid">
  <kodit-field fieldLabel="eOtpremnice">
    <kodit-eotpremnica-multiselect
      [otpremniceArray]="eOtpremnicaArray"
      (selectedOtpremnice)="selectedOtpremnice($event)"
      [tipDokumentaOtpremnica]="tipOtpremnica"
      [racunId]="racunId"
    ></kodit-eotpremnica-multiselect>
  </kodit-field>

  <kodit-field fieldLabel="ePrijemnice" class="p-mt-3">
    <kodit-eotpremnica-multiselect
      [otpremniceArray]="ePrijemnicaArray"
      (selectedOtpremnice)="selectedPrijemnice($event)"
      [tipDokumentaOtpremnica]="tipPrijemnica"
      [racunId]="racunId"
    ></kodit-eotpremnica-multiselect>
  </kodit-field>
</div>
